import React, { useEffect, useState } from 'react';
import styles from './Chips.module.scss';
import InputTextLengthCounter from '../../../../../core/components/inputs/inputTextLengthCounter/InputTextLengthCounter';
import { isEmpty } from '../../../../../core/utils/ValidForm';

function Chips({
    name,
    value = [],
    onChange,
    onDelete,
    optionLabel = 'descFonte',
    optionValue = 'id',
    disabled,
    maxLen = 200,
    ...rest
}) {
    const [inputValue, setInputValue] = useState('');
    const [selecionados, setSelecionados] = useState([]);
    const [dinamicClass, setDinamicClass] = useState('');

    useEffect(() => {
        if (Array.isArray(value)) {
            setInputValue('');
            setSelecionados(value);
        }
    }, [value]);

    return (
        <div
            className={`p-inputtext p-component ${styles.container} ${dinamicClass} ${
                disabled ? styles.isDisable : ''
            }`}
        >
            <div className={styles.containerValues}>
                {selecionados?.map((el, index) => {
                    const removeList = () =>
                        setSelecionados(
                            selecionados.filter((item) =>
                                item?.[optionValue]
                                    ? item?.[optionValue] !== el?.[optionValue]
                                    : item !== el
                            )
                        );
                    return (
                        <div key={index}>
                            <div className={disabled ? styles.isDisable : ''}>
                                {el?.[optionLabel] ?? el}
                            </div>
                            {!disabled && (
                                <div
                                    onClick={() =>
                                        onDelete ? onDelete({ el, removeList }) : removeList()
                                    }
                                >
                                    <i className="pi pi-times-circle" />
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
            <div className={styles.containerInput}>
                <InputTextLengthCounter maxLen={maxLen}>
                    <input
                        name={name}
                        type="text"
                        value={inputValue}
                        onChange={(ev) => setInputValue(ev.target.value)}
                        onFocus={() => setDinamicClass(styles.focus)}
                        onBlur={() => setDinamicClass('')}
                        onKeyDown={(ev) => {
                            if (ev.key === 'Enter' && onChange) {
                                const val = `${inputValue}`.trim();
                                if (!isEmpty(val)) {
                                    const exist = selecionados.find((el) => el === val);
                                    if (!exist) {
                                        onChange(name, [...selecionados, val]);
                                    } else {
                                        setInputValue('');
                                    }
                                }
                            }
                        }}
                        disabled={disabled}
                        {...rest}
                    />
                </InputTextLengthCounter>
            </div>
        </div>
    );
}

export default Chips;
